<template>
	
	<div>
		
		<ContentAreaTitle :title="$route.meta.title">
			<template slot="actions">
				<el-button type="success" icon="el-icon-check" @click="onClickFormAction('save')" :loading="$store.state.loading" round>Save</el-button>
			</template>
		</ContentAreaTitle>
		
		<el-form label-position="top" :class="{ 'form-disabled': formDisabled }" :model="user" :rules="userFormRules" ref="userForm">
			
			<el-row :gutter="24">
				
				<el-col :span="24">
					
					<el-form-item label="Name" prop="name">
						<el-input v-model="user.name"></el-input>
					</el-form-item>
					
					<el-form-item v-if="$route.meta.state == 'add'" label="Password" prop="password">
						<el-input v-model="user.password"></el-input>
					</el-form-item>
					
					<el-form-item label="Nickname">
						<el-input v-model="user.nickname"></el-input>
					</el-form-item>
					
					<el-form-item label="Email Address" prop="email">
						<el-input v-model="user.email" type="email"></el-input>
					</el-form-item>
					
					<el-form-item label="Phone Number">
						<el-input v-model="user.phone"></el-input>
					</el-form-item>
					
				</el-col>
				
				<el-col :span="24">
					<hr>
				</el-col>
				
				<el-col :span="12">
					<el-form-item label="Group">
						<el-select v-model="user.type" placeholder="Group" style="width: 100%;">
							<el-option value="Staff">Staff</el-option>
							<el-option value="Contractor">Contractor</el-option>
							<el-option value="Client">Client</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				
				<el-col :span="12">
					<el-form-item label="Role">
						<el-input v-model="user.role"></el-input>
					</el-form-item>
				</el-col>
				
				<el-col :span="12">
					<el-form-item label="Hourly Rate">
						<el-input-number v-model="user.rate" controls-position="right" :value="0" style="width: 100%;"></el-input-number>
					</el-form-item>
				</el-col>
				
				<el-col :span="12">
					<el-form-item label="Wage">
						<el-input-number v-model="user.wage" controls-position="right" :value="0" :step="1000" style="width: 100%;"></el-input-number>
					</el-form-item>	
				</el-col>
				
				<el-col :span="24">
					<el-form-item label="Permissions">
						<el-select v-model="user.permissions" size="large" placeholder="Select permissions" value-key="id" style="width: 100%;" :multiple="true">
							<el-option v-for="permission in permissions" :value="permission" :label="permission.name_display" :key="permission.id"/>
						</el-select>
					</el-form-item>	
				</el-col>
				
			</el-row>
			
		</el-form>
		
	</div>
	
</template>

<script>

	import ContentAreaTitle from "@/components/ContentAreaTitle";
	
	export default {
		
		name: "UsersAddEdit",
		
		components: { ContentAreaTitle },
		
		data() {
			
			return {
				
				/*user: {
					name: "",
					nickname: "",
					email: "",
					phone: "",
					password: "1234567890",
					type: "Staff",
					role: "",
					rate: 0,
					wage: 0,
				},*/
				
				user: {},
				
				permissions: [],
				
				userFormRules: {
					name: [{
						required: true,
						message: "Please give this user a name",
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: "Please give this user a password",
						trigger: "blur"
					}],
					email: [{
						validator: (rule, value, callback) => {
							const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
							const valid = re.test(String(value).toLowerCase());
							if (valid) {
								callback();
							} else {
								callback(new Error(rule.message));
							}
						},
						required: true,
						message: "Please enter a valid email address",
						trigger: "blur"
					}],
				}
				
			}
			
		},
		
		computed: {
			
			formDisabled() {
				if (this.$route.meta.state == "add") {
					return false;
				} else if (this.$route.meta.state == "edit") {
					return !this.user.id;
				}
				return false;
			},
			
		},
		
		methods: {
			
			onClickFormAction(action) {
				
				// Variables.
				
				const state = this.$route.meta.state;
				
				// What action / button was clicked?
				
				if (action == "save") {
					
					this.$refs.userForm.validate((valid) => {
						
						if (valid) {
							
							// Add or editing?
							
							const request = {
								url: "users",
								successMessage: "This user has been added.",
								errorMessage: "An unknown error occurred while adding this user.",
							}
							
							if (state == "edit") {
								request.url = `users/${this.user.id}`;
								request.successMessage = "This user has been updated.";
								request.errorMessage = "An unknown error occurred while updating this user.";
							}
							
							// Loading...
							
							this.$store.commit("setLoading", {type: "start"});
							
							// Post!
							
							this.axios.post(request.url, this.user).then((response) => {
								
								// Success or not?
								
								if (response.statusText == "OK") {
									
									// Not loading anymore.
									
									this.$store.commit("setLoading", {type: "finish", message: request.successMessage});
									
									// Update stored data.
									
									this.$store.commit("setApiData", {key: "users", data: response.data.users});
									
									// Load 'Edit' view?
									
									if (state == "add") {
										this.$router.push({name: "users/edit", params: {id: response.data.user.id}});
									}
									
								}
								
							}).catch((e) => {
								
								this.$store.commit("setLoading", {type: "error", message: request.errorMessage});
								
							});
							
						} else {
							
							return false;
							
						}
						
					});
					
				} else if (action == "cancel") {
					
					this.$router.push({name: "users"});
					
				}
				
			}
			
		},
		
		created() {
			
			// Reset user data.
			
			this.$set(this, "user", {});
			
			// Redirect them?
			
			if (this.$route.params.id === this.$auth.user().id) {
				this.$router.replace({ name: "dashboard" });
			}
			
			// What page state?
			
			if (this.$route.meta.state === "add") {
				
				
				
			} else if (this.$route.meta.state === "edit") {
				
				// Loading.
				
				this.$store.commit("setLoading", {type: "start"});
				
				// Get user.
				
				this.axios.get(`users/${this.$route.params.id}`).then(response => {
					if (response.status == 200) {
						// Not loading.
						this.$store.commit("setLoading", {type: "finish"});
						// Update stored data.
						this.$set(this, "user", response.data);
					}
				}).catch(e => {
					this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while loading this project." });
				});
				
			}
			
			// Get permissions.
			
			this.axios.get("permissions").then((r) => {
				if (r.status == 200) {
					this.$set(this, "permissions", r.data);
				}
			});
			
		},
		
	}
	
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/Users/AddEdit.vue